// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";

// Libraries
import { Subscription } from "rxjs";

// Afidium
import { ViewsService } from 'libraries/view/views.service';
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ProcessingSearchParameters } from "../../shared/models/ProcessingSearchParameters";
import { SashaBreadcrumbService } from "../../shared/components/breadcrumb/sasha-breadcrumb.service";
import { BookingSearchParameters } from '../../shared/models/BookingSearchParameters';

import { SashaPageComponent } from '../sasha-page.component';
import { tap } from 'rxjs/operators';
import { TitleService } from 'app_sasha/shared/services/title/title.service';
import { Yii } from 'libraries/interfaces/Yii';

@Component({
    selector: 'processing-search',
    template: `
        <div class="app-wrapper app-sasha">
            <sasha-breadcrumb></sasha-breadcrumb>
            <processing-search-form
                [searchParameters]="searchParameters"
                (onSubmit)="onSubmit($event)"
                (onReset)="onReset()">
            </processing-search-form>
        </div>
    `,
})
export class SearchComponent extends SashaPageComponent implements OnInit, OnDestroy {
    public searchParameters: ProcessingSearchParameters = new ProcessingSearchParameters();


    private queryParamsSubscription: Subscription;

    //////////////////////////////////// CONSTRUCTOR ////////////////////////////////////

    constructor(
        protected views: ViewsService,
        public appRootService: AppRootService,
        private readonly breadcrumbService: SashaBreadcrumbService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly titleService: TitleService,
    ) {
        super(views, appRootService);
    }


    //////////////////////////////////// LIFECYCLE METHODS ////////////////////////////////////

    public ngOnInit(): void {
        super.ngOnInit();

        this.titleService.setTitle(Yii.t("wui-sasha-js", "Recherche de traitements"));

        this.queryParamsSubscription = this.route
            .queryParams
            // .first((params) => Object.keys(params).length > 0)
            .pipe(
                tap((params: any) => {
                    this.searchParameters = ProcessingSearchParameters.fromRouteParams(params);
                    this.breadcrumbService.setProcessingSearch(this.searchParameters);
                })
            )
            .subscribe();
    }

    public ngOnDestroy(): void {
        this.queryParamsSubscription.unsubscribe();
    }

    //////////////////////////////////// COMPONENT METHODS ////////////////////////////////////


    public onSubmit(searchParameters: BookingSearchParameters): void {
        const queryParams = searchParameters.convertToUrlParameters();
        // first refresh the '/search/' url with parameters
        // necessary to correctly use browser navigation
        this.router.navigate(
            ['/sasha/processing/search'], { queryParams }
        ).then(// then change route to reach '/search-result/'
            () => this.router.navigate(
                ['/sasha/processing/search-result'], { queryParams }
            )
        );
    }

    public onReset(): void {
        const params = new ProcessingSearchParameters();
        this.router.navigate(
            ['.'],
            {
                relativeTo: this.route,
                queryParams: params.convertToUrlParameters(),
            },
        );
    }


}
